"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatYearMonth = exports.checkPayslips = exports.parsePayslip = void 0;
const tslib_1 = require("tslib");
//import parse from 'csv-parse/lib/sync' - doesn't work in common workspace
const lodash_1 = tslib_1.__importDefault(require("lodash"));
const normalizeEntity_1 = require("./normalizeEntity");
const labels = {
    'Meno': { key: 'fullName' },
    'Obdobie': { key: 'yearMonth', convert: yearMonth },
    'Celková cena práce': { key: 'totalCost', convert: toNumber },
    'Osobné číslo': { key: 'accountingNumber', limit: 5 },
    // employer and legalForm doesn't have labels, processed individually
};
const legalForms = {
    'Hlavný pracovný pomer': 'employee',
    'Dohoda o brig. práci študenta': 'student',
    'Dohoda o pracovnej činnosti': 'serviceAgreement',
    'Dohoda o vykonaní práce': 'oneTimeWork',
};
const hasValue = (value) => {
    if (value && !/^[[:space:]]*$/.test(value)) {
        return value.trim();
    }
    else {
        return false;
    }
};
const findValue = (row, i) => {
    let v;
    while ((v = hasValue(row[i])) === false && i < row.length)
        i++;
    return v;
};
const rowBegin = (row) => {
    for (let i = 0; i < row.length; i++) {
        if (hasValue(row[i]))
            return i;
    }
    return false;
};
const findNonEmptyRow = (records, i) => {
    let b;
    if (i >= records.length)
        return false;
    while ((b = rowBegin(records[i])) === false) {
        i++;
        if (i >= records.length)
            return false;
    }
    return [i, b];
};
const findEmptyRow = (records, i) => {
    if (i >= records.length)
        return false;
    while (rowBegin(records[i]) !== false) {
        i++;
        if (i >= records.length)
            return false;
    }
    return i;
};
function toString(v, x, y, records) {
    return [v ? v.toString() : undefined];
}
function toNumber(v, x, y, records) {
    return [Number(v)];
}
const formatYearMonth = (year, month) => `${year}-${String(month).padStart(2, '0')}`;
exports.formatYearMonth = formatYearMonth;
function yearMonth(v, x, y, records) {
    if (v) {
        let match, year, month;
        if ((match = /^(\d\d\d\d)-(\d\d?)$/.exec(v))) {
            year = match[1];
            month = match[2];
        }
        else if ((match = /^(\d\d?)[/-](\d\d\d\d)$/.exec(v))) {
            month = match[1];
            year = match[2];
        }
        return [formatYearMonth(year, month)];
    }
    else {
        return [v];
    }
}
function convertLegalForm(f) {
    if (legalForms[f]) {
        return legalForms[f];
    }
    else {
        return f;
    }
}
const mapLabels = (records, startRow, endRow, labels, obj) => {
    var _a;
    for (let y = startRow; y <= endRow; y++) {
        const row = records[y];
        const l = row.length;
        let x = 0;
        // Prerequisity: labels are unique and same string cannot occure as a value
        // search for label
        while (x < l) {
            const label = hasValue(row[x++]);
            if (label !== false && labels[label] != null) {
                // search for value
                const limit = labels[label].limit ? Math.min(x + labels[label].limit - 1, l) : l;
                while (x < limit) {
                    const value = hasValue(row[x++]);
                    if (value !== false) {
                        // this allows to collect multiple values for single label (e.g. Dovolenka)
                        const [convertedValue, newX] = ((_a = labels[label].convert) !== null && _a !== void 0 ? _a : toString)(value, x, y, records);
                        obj[labels[label].key] = convertedValue;
                        x = newX !== null && newX !== void 0 ? newX : x;
                        break; // search for another label
                    }
                }
            }
        }
    }
};
const parsePayslip = (file, parseCsvSyncFn) => {
    // import in "common" doesn't work
    const records = parseCsvSyncFn(file.contents, {
        columns: false,
    });
    const payslips = []; // Object[]
    let startRow = 0;
    let startPos = 0;
    while (startRow < records.length) {
        [startRow, startPos] = findNonEmptyRow(records, startRow);
        const endRow = (findEmptyRow(records, startRow) || records.length) - 1;
        const legalForm = convertLegalForm(findValue(records[startRow], startPos + 1));
        const payslip = {
            employer: hasValue(records[startRow][startPos]),
            legalForm: legalForm || undefined,
            lineNo: startRow + 1,
            fileName: file.name,
        };
        mapLabels(records, startRow + 1, endRow, labels, payslip);
        payslips.push(payslip);
        startRow = endRow + 1;
    }
    return payslips;
};
exports.parsePayslip = parsePayslip;
const formatPayslipIdentifier = (payslip) => `${payslip.lineNo} (in ${payslip.fullName})`;
const checkPayslip = ({ payslip /*Object*/, year, month, employer, relevantEmployees /*Object[]*/, alreadyCheckedPayslips, /*{accountingNumber: {legalForm: payslip}}*/ }) => {
    const errors = [];
    const warnings = [];
    // employer must be similar
    if (employer == null || employer.length === 0 ||
        (0, normalizeEntity_1.normalizeEntity)(payslip.employer) !== (0, normalizeEntity_1.normalizeEntity)(employer)) {
        errors.push({
            id: formatPayslipIdentifier(payslip),
            message: `Employer mismatch: form: ${employer}, payslip: ${payslip.employer}`,
        });
    }
    if (!payslip.accountingNumber) {
        errors.push({
            id: formatPayslipIdentifier(payslip),
            message: 'Missing accounting number',
        });
    }
    if (payslip.legalForm == null) {
        errors.push({
            id: formatPayslipIdentifier(payslip),
            message: 'Missing legalForm',
        });
    }
    // month must match
    const yearMonth = formatYearMonth(year, month);
    if (payslip.yearMonth !== yearMonth) {
        errors.push({
            id: formatPayslipIdentifier(payslip),
            message: `Month mismatch: form: ${yearMonth}, payslip: ${payslip.yearMonth}`,
        });
    }
    if (payslip.accountingNumber && payslip.legalForm) {
        const duplicity = lodash_1.default.get(alreadyCheckedPayslips, [payslip.accountingNumber, payslip.legalForm]);
        if (duplicity) {
            errors.push({
                id: formatPayslipIdentifier(payslip),
                message: `Duplicate acc. number and legal form in ${duplicity.fileName} #${formatPayslipIdentifier(duplicity)} and ${payslip.fileName} #${formatPayslipIdentifier(payslip)}`,
            });
        }
        const tmp = alreadyCheckedPayslips[payslip.accountingNumber];
        const notMatchingNamePayslips = (tmp ? Object.values(tmp) : [])
            .filter((p) => p.fullName !== payslip.fullName);
        if (notMatchingNamePayslips.length > 0) {
            errors.push({
                id: formatPayslipIdentifier(payslip),
                message: `Acc. number ${payslip.accountingNumber} is used with different names ${payslip.fullName}, ${notMatchingNamePayslips[0].fullName}`,
            });
        }
        const employees = relevantEmployees
            // eslint-disable-next-line camelcase
            .filter(({ accounting_number }) => accounting_number === payslip.accountingNumber);
        if (employees.length > 1) {
            warnings.push({
                id: formatPayslipIdentifier(payslip),
                message: `Duplicated acc. number ${payslip.accountingNumber} in DB, check EMS&reload EMS+JIRA`,
            });
        }
        else if (employees.length === 0) {
            warnings.push({
                id: formatPayslipIdentifier(payslip),
                message: `Acc. number ${payslip.accountingNumber} not in DB (or has a different employer or month), check EMS&reload EMS+JIRA`,
            });
        }
        else {
            const e = employees[0];
            const fullName = `${e.first_name} ${e.last_name}`;
            if (fullName !== payslip.fullName) {
                warnings.push({
                    id: formatPayslipIdentifier(payslip),
                    message: `Name mismatch for ${payslip.accountingNumber}: DB: ${fullName}, payslip: ${payslip.fullName}`,
                });
            }
        }
        const accountingNumberDuplicities = alreadyCheckedPayslips[payslip.accountingNumber];
        if (accountingNumberDuplicities &&
            !lodash_1.default.keys(accountingNumberDuplicities).includes(payslip.legalForm)) {
            const duplicatesString = lodash_1.default.values(accountingNumberDuplicities).map((p) => `${p.fileName} line #${formatPayslipIdentifier(p)}`).join(', ');
            warnings.push({
                id: formatPayslipIdentifier(payslip),
                message: `Duplicate accounting number in ${duplicatesString}`,
            });
        }
        lodash_1.default.set(alreadyCheckedPayslips, [payslip.accountingNumber, payslip.legalForm], payslip);
    }
    return [errors, warnings];
};
const checkPayslips = ({ payslips /*Object[]*/, year, month, employer, relevantEmployees /*Object[]*/, // relevant means already filtered by year, month and employer
alreadyCheckedPayslips, }) => {
    const [errors, warnings] = payslips
        .map((payslip) => checkPayslip({
        payslip,
        year,
        month,
        employer,
        relevantEmployees,
        alreadyCheckedPayslips,
    }))
        .reduce((acc, curr) => [acc[0].concat(curr[0]), acc[1].concat(curr[1])], [[], []]);
    return [errors, warnings];
};
exports.checkPayslips = checkPayslips;
